if (!customElements.get('delivery-time')) {
  customElements.define(
    'delivery-time',
    class DeliveryTime extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.section = document.getElementById(this.dataset.sectionId);

        if (!this.section) return;

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if ('shopify-section-' + event.data.sectionId === this.dataset.sectionId) {
              this.updateBlock(event.data.html.querySelector(this.nodeName));
            }
          },
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateBlock(element) {
        if (!element) {
          if (this.innerHTML) this.innerHTML = '';
          return;
        }

        if (element.innerHTML === this.innerHTML) return;

        const fragment = document.createDocumentFragment();
        Array.from(element.childNodes).forEach((node) => {
          fragment.appendChild(node.cloneNode(true));
        });

        this.replaceChildren(fragment);
      }
    }
  );
}
